import {
  Heading,
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Flex, Separator } from '@chakra-ui/react';
import { format } from 'date-fns';
import { useAuth } from '../../hooks';
import { TasksColumn } from './TasksColumn';
import AppointmentsColumn from 'components/ProviderHome/AppointmentsColumn';
import useCareTeamMember from 'components/HealthCoachDashboard/hooks/useCareTeamMember';
import { useDashboardCoach } from 'components/HealthCoachDashboard/hooks/useDashboardCoach';
import CareMemberFilter from 'components/ProviderHome/CareMemberFilter';
import { useEffect, useState } from 'react';

export const ProviderHome = () => {
  const { user } = useAuth();
  const { initialSelectedProviderId, providerOptions } = useCareTeamMember();
  const { initialSelectedCoachId, coachOptions } = useDashboardCoach();
  const [memberId, setMemberId] = useState<string>();

  const initialMemberId = initialSelectedCoachId || initialSelectedProviderId;

  useEffect(() => {
    if (!memberId && initialMemberId) {
      setMemberId(initialMemberId);
    }
  }, [memberId, initialMemberId]);

  const selectedHealthieId = [
    ...(coachOptions || []),
    ...(providerOptions || []),
  ].find(
    ({ value }) => value === (!!memberId ? memberId : initialMemberId)
  )?.healthieId;

  const dateLabel = format(new Date(), 'EEEE, MMMM d');

  return (
    <VStack h="100%" w="100%" overflow="hidden" gap={0} align="stretch">
      <Flex
        justify="space-between"
        align="flex-start"
        px={8}
        pt={6}
        pb={6}
        borderBottomWidth="1px"
        borderColor="muted.200"
        flexShrink={0}
      >
        <HStack gap={3} align="baseline" w={'100%'}>
          <Heading size="lg">
            Hello, {user?.first_name} {user?.last_name}
          </Heading>

          <Text color="muted.400">{dateLabel}</Text>

          <CareMemberFilter
            setSelectedId={setMemberId}
            selectedId={memberId}
            coachOptions={coachOptions}
            providerOptions={providerOptions}
          />
        </HStack>
      </Flex>

      <Flex align="stretch" flex={1} minH={0}>
        <HStack alignItems={'stretch'} w={'100%'} minH={0}>
          <AppointmentsColumn memberId={selectedHealthieId} />
          <Separator
            alignSelf={'stretch'}
            color={'cloud'}
            orientation={'vertical'}
          />

          <TasksColumn memberId={selectedHealthieId} />
        </HStack>
      </Flex>
    </VStack>
  );
};
